export const OpenFolderIcon = (): JSX.Element => (
  <svg width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.9 26.25c4.684 0 8.475 4.17 8.475 9.334v58.2c0 5.148-3.787 9.335-8.475 9.335H14.092c-4.672 0-8.467-4.185-8.467-9.335v-59.53c0-5.164 3.787-8.01 8.467-8.01"
      fill="#D69661"
    />
    <path
      d="M34.24 15c1.578 0 2.859 1.406 2.859 3.15l18.75 20.08c0 1.736-1.283 3.146-2.86 3.146H8.481c-1.575 0-2.852-1.41-2.852-3.147V18.15c0-1.744 1.279-3.15 2.852-3.15h25.758Z"
      fill="#D69661"
    />
    <path
      d="M105.769 43.02c4.68 0 8.471 4.17 8.471 9.334l-13.063 41.438c-1.425 3.71-5.663 9.335-10.35 9.335H14.093c-4.673 0-8.468-4.185-8.468-9.335l13.067-41.438c1.933-3.603 5.662-9.334 10.342-9.334"
      fill="#E5B687"
    />
  </svg>
);
